import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/PageHero";
import Seo from "@/components/Seo";
import { HERO_ART } from "@/lib/heroes";
import ForumList from "@/components/ForumList";
import InviteButton from "@/components/InviteButton";

export default function Discussions() {
  const { pick } = useLang();
  return (
    <div data-testid="discussions-page">
      <Seo path="/discussions" title="Discussions — Community Conversations on Dharma"
        description="Join respectful conversations on Sanatana Dharma — festivals, practice, philosophy, temples and living tradition." />
      <PageHero art={HERO_ART.knowledge} overline={pick("समुदाय · चर्चा मंच", "Community · Discussions")}
        deva="चर्चा मंच" en={pick("चर्चा मंच", "Discussions")}
        tagline={pick("धर्म, साधना, पर्व एवं परंपरा पर श्रद्धापूर्ण संवाद। प्रश्न रखें, अनुभव साझा करें, एक-दूसरे से सीखें।", "Respectful conversations on dharma, practice, festivals and tradition. Share, ask and learn from fellow sadhaks.")} />
      <ForumList kind="discussion" basePath="/discussions" />
      <div className="mx-auto max-w-5xl px-5 pb-10 md:px-8"><InviteButton context={pick("चर्चा मंच", "Discussions")} testid="discussions-invite" /></div>
    </div>
  );
}
